export const NOTIFICATION_ROUTES = {
  EXPIRY: (relatedIds) => relatedIds?.labSetupId ? `/labs-stock-management/${relatedIds.labSetupId}?section=stock-management&expand=first` : null,
  VARIANCE: (relatedIds) => (relatedIds?.labSetupId && relatedIds?.stockRegisterId) ? 
    `/labs-stock-management/${relatedIds.labSetupId}?section=variance-reports&expand=${relatedIds.stockRegisterId}` : null,
  FOLLOW_UP: (relatedIds) => (relatedIds?.labSetupId && relatedIds?.stockRegisterId) ? 
    `/labs-stock-management/${relatedIds.labSetupId}?section=variance-reports&expand=${relatedIds.stockRegisterId}` : null, // Variance reports accessed via stock management
};

// Special handling for notifications that need to expand specific sections
export const NOTIFICATION_ACTIONS = {
  VARIANCE: { expandSection: 'variance-reports' },
  FOLLOW_UP: { expandSection: 'variance-reports' },
  EXPIRY: { expandSection: 'stock-management' },
};

export const parseNotificationParams = (searchParams) => {
  const params = new URLSearchParams(searchParams);
  return {
    section: params.get('section'),
    expandRegisterId: params.get('expand')
  };
};

export const getNotificationRoute = (type, relatedIds) => {
  const routeHandler = NOTIFICATION_ROUTES[type];
  return routeHandler ? routeHandler(relatedIds) : null;
};

export const isNotificationRoutable = (type) => {
  return !!NOTIFICATION_ROUTES[type];
};

export const getNotificationTypeLabel = (type) => {
  const labels = {
    EXPIRY: 'Stock Expiry',
    VARIANCE: 'Stock Variance',
    FOLLOWUP: 'Follow-up Time',
  };
  return labels[type] || 'Notification';
};

export const getNotificationAction = (type) => {
  return NOTIFICATION_ACTIONS[type] || null;
};

export const hasNotificationAction = (type) => {
  return !!NOTIFICATION_ACTIONS[type];
};

export const extractRelatedIds = (notification) => {
  if (notification.relatedIds) {
    return notification.relatedIds;
  }
  
  if (notification.linkedId) {
    return {
      stockRegisterId: notification.linkedId,
      labSetupId: notification.labSetupId || notification.linkedId
    };
  }
  
  return {};
};
